export default "__VITE_ASSET__B7poQr4s__"